import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import EmploymentMotive from './employment-motive.interface';
import { EmploymentMotiveService } from './employment-motive.service';

const service = new EmploymentMotiveService();

export interface EmploymentMotiveState {
   employmentMotives: Array<EmploymentMotive>;
}

const EmploymentMotiveStore: Module<EmploymentMotiveState, StoreState> = {
   namespaced: true,
   state: {
      employmentMotives: [],
   },
   getters: {
      employmentMotives(state) {
         return state.employmentMotives;
      },
   },
   mutations: {
      setEmploymentMotives(state, employmentMotives: Array<EmploymentMotive>) {
         state.employmentMotives = employmentMotives;
      },
   },
   actions: {
      async getEmploymentMotives(context: any) {
         return await service.getEmploymentMotives().then((response) => {
            context.commit('setEmploymentMotives', response);
            return response;
         });
      },
   },
};

export default EmploymentMotiveStore;
